import { useMutation, useQueryClient } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export const useMutationDeleteMaster = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (masterUuid: string) => {
      return await baseClient
        .getApi(MasterApi)
        .deleteMaster({ masterUuid })
        .catch(handleHTTPError)
    },
    onSuccess: (_data, masterUuid) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.masters })
      queryClient.removeQueries({ queryKey: queryKeys.master(masterUuid) })
    },
  })
}
